import { kebabCase } from "lodash";

export const getLogoUrl = (companyName: string | null) => {
  return `/images/logos/${kebabCase(companyName?.toLowerCase())}.png`;
};
